








































































// LEGACY-V2-BRIDGE — this banner and its migrate button go away with the rest of the v2 admin.
import { getMigrationConsoleUrl } from '../v3Redirect';

/**
 * Booking page for a guided tour of Rambox 3, the same one the website's "Request a demo" uses. For an admin
 * who isn't sure about moving yet: we walk them through it before they commit.
 */
const DEMO_URL = 'https://koalendar.com/e/rambox-demo';

/**
 * Dashboard banner that invites a v2 Enterprise organization to move to Rambox 3.
 *
 * Whoever sees it already has Teams, so it doesn't sell Teams: it lists only what v3 adds on top of what
 * they use today, and its main button takes them, already signed in, to the console's migration wizard.
 * The features come from shipped v3 copy (the desktop's "What's new" tour and the console), not marketing.
 * It can't be dismissed on purpose: moving to v3 is the point.
 */
export default {
	name: 'V3Banner',
	data() {
		return {
			// Keys under `dashboard.v3.groups` / `dashboard.v3.features`; order is the order they render in.
			// Things the v2 admin already has (teams, workspaces, Full/Intermediate/Basic, white label) are
			// left out: listing them as news would be wrong for this reader.
			groups: [
				{ key: 'team', features: ['search', 'ai', 'focus'] },
				{ key: 'admins', features: ['permissions', 'memberPermissions', 'theme'] },
			],
			migrating: false,
		};
	},
	methods: {
		/**
		 * Same tab on purpose: migrating signs the admin out of Rambox 2, so there's nothing to come back to.
		 * The handoff code is asked for here, on click, because it only lives for a minute.
		 */
		async migrate(): Promise<void> {
			this.migrating = true;
			const user = this.$firebase.auth().currentUser;
			// A token that can't be refreshed (expired session, network) must not leave the button spinning:
			// without one the API answers 401 and getMigrationConsoleUrl falls back to the company sign-in.
			const idToken = user ? await user.getIdToken().catch(() => '') : '';
			// The v2 organization id is the v3 one too (the tenant's displayName), so the fallback can open
			// this company's sign-in already filled in.
			window.location.href = await getMigrationConsoleUrl(idToken, this.$store.getters.organizationId);
		},
		requestDemo(): void {
			// noopener: a third-party page, it gets no handle back on the admin.
			window.open(DEMO_URL, '_blank', 'noopener');
		},
	},
};
